import { useState, useEffect } from "react";

const BASE = "https://support.gs-group.fr/api";
const hdr = () => ({ "Content-Type":"application/json", Authorization:"Bearer "+localStorage.getItem("nexo_token") });

/*
  Notification flash "human-in-the-loop"
  Props:
    notifs    : [{ id, titre, message, tech, onConfirm, onModify }]
    onDismiss : (id) => void
    T         : theme
*/
export default function EscaladeNotif({ notifs=[], onDismiss, T }) {
  const [visible, setVisible] = useState([]);

  useEffect(()=>{
    setVisible(notifs.map(n=>n.id));
  },[notifs]);

  const dismiss = (id) => {
    setVisible(v=>v.filter(x=>x!==id));
    setTimeout(()=>onDismiss&&onDismiss(id), 300);
  };

  const active = notifs.filter(n=>visible.includes(n.id));
  if(!active.length) return null;

  return (
    <div style={{
      position:"fixed", bottom:24, right:24, zIndex:900,
      display:"flex", flexDirection:"column", gap:10,
      maxWidth:380,
    }}>
      {active.map((n,i)=>(
        <div key={n.id} style={{
          background:T.card,
          border:`1.5px solid ${T.warning}55`,
          borderRadius:16,
          boxShadow:`0 8px 32px rgba(0,0,0,0.25), 0 0 0 1px ${T.warning}22`,
          overflow:"hidden",
          animation:"escalade-in 0.3s cubic-bezier(0.16,1,0.3,1)",
        }}>
          <style>{`@keyframes escalade-in{from{opacity:0;transform:translateX(24px)}to{opacity:1;transform:translateX(0)}}`}</style>

          {/* Bandeau urgence */}
          <div style={{background:`${T.warning}18`,borderBottom:`1px solid ${T.warning}30`,padding:"10px 14px",display:"flex",alignItems:"center",gap:8}}>
            <span style={{fontSize:18}}>⚡</span>
            <div style={{flex:1,minWidth:0}}>
              <div style={{fontSize:12,fontWeight:800,color:T.warning,textTransform:"uppercase",letterSpacing:"0.5px"}}>Décision requise</div>
              <div style={{fontSize:13,fontWeight:700,color:T.text,overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap"}}>{n.titre}</div>
            </div>
            <button onClick={()=>dismiss(n.id)} style={{background:"none",border:"none",color:T.muted,cursor:"pointer",fontSize:16,flexShrink:0}}>✕</button>
          </div>

          {/* Corps */}
          <div style={{padding:"12px 14px"}}>
            <div style={{fontSize:12,color:T.muted,lineHeight:1.6,marginBottom:10}}>{n.message}</div>

            {/* Tech suggéré */}
            {n.tech&&(
              <div style={{display:"flex",alignItems:"center",gap:10,padding:"8px 12px",background:T.bg,borderRadius:10,border:`1px solid ${T.border}`,marginBottom:12}}>
                <div style={{width:34,height:34,borderRadius:"50%",background:`${T.accent}20`,border:`2px solid ${T.accent}`,display:"flex",alignItems:"center",justifyContent:"center",fontSize:12,fontWeight:800,color:T.accent,flexShrink:0}}>
                  {(n.tech.prenom||"?")[0]}{(n.tech.nom||"?")[0]}
                </div>
                <div style={{flex:1,minWidth:0}}>
                  <div style={{fontSize:13,fontWeight:700,color:T.text}}>{n.tech.prenom} {n.tech.nom}</div>
                  <div style={{fontSize:11,color:T.muted}}>{n.tech.raison}</div>
                </div>
                <div style={{fontSize:12,fontWeight:800,color:T.accent,background:T.accentDim,borderRadius:8,padding:"3px 8px"}}>
                  Score {n.tech.score}
                </div>
              </div>
            )}

            {/* Actions */}
            <div style={{display:"flex",gap:8}}>
              <button onClick={async ()=>{
              n.onConfirm&&n.onConfirm();
              // Email notification au tech + client
              if(n.interId && n.tech?.user_id) {
                fetch(`${BASE}/interventions/${n.interId}/notify-reassignment`,{
                  method:"POST", headers:hdr(),
                  body:JSON.stringify({ new_tech_id:n.tech.user_id, reason:n.tech.raison }),
                }).catch(()=>{});
              }
              dismiss(n.id);
            }} style={{
                flex:2,padding:"9px",borderRadius:10,border:"none",
                background:`linear-gradient(135deg,${T.success},#059669)`,
                color:"#fff",fontSize:13,fontWeight:700,cursor:"pointer",
              }}>✅ Confirmer</button>
              <button onClick={()=>{n.onModify&&n.onModify();dismiss(n.id);}} style={{
                flex:1,padding:"9px",borderRadius:10,
                border:`1px solid ${T.border}`,background:"transparent",
                color:T.text,fontSize:13,fontWeight:600,cursor:"pointer",
              }}>✏️ Modifier</button>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
}
